import React, { PropsWithChildren } from "react";

import { StringMap } from "./lib/types";
import { clsx } from "clsx";
import Loader from "./Loader";

type Props = {
  segmentType?: "div" | "header" | "main" | "section" | "aside" | "footer" | "span";
  title?: string;
  header?: string;
  loading?: boolean;
  className?: string;
  id?: string;
  flex?: boolean;
  flexAllTheTime?: boolean;
  verticalCenter?: boolean;
  justifyCenter?: boolean;
  columns?: boolean;
  fullWidth?: boolean;
  bordered?: boolean;
  rounded?: boolean;
  last?: boolean;
  bg?: "grey" | "blue";
  mx?: string;
  my?: string;
  mt?: string;
  mb?: string;
  ml?: string;
  mr?: string;
  px?: string;
  py?: string;
  pl?: string;
  pr?: string;
  pt?: string;
  pb?: string;
  style?: StringMap<any>;
  forwardedRef?: any;
};

const Segment = ({
  segmentType = "div",
  title,
  header,
  loading,
  className,
  id,
  flex,
  flexAllTheTime,
  verticalCenter,
  justifyCenter,
  columns,
  bordered,
  fullWidth,
  rounded,
  last,
  bg,
  children,
  style,
  forwardedRef,
  mx,
  my,
  ml,
  mr,
  mt,
  mb,
  py,
  px,
  pl,
  pr,
  pt,
  pb,
}: PropsWithChildren<Props>) => {
  const Type = segmentType;

  return (
    <Type
      style={style}
      ref={forwardedRef}
      id={id}
      className={clsx({
        segment: true,
        bordered,
        rounded,
        "full-width": fullWidth,
        ac: verticalCenter,
        jc: justifyCenter,
        "grid-row": flex,
        flex: flexAllTheTime,
        "grid-columns": columns,
        "grid-last": last,
        [`${className ? className : ""}`]: className,
        [`${bg ? "bg-" + bg : ""}`]: bg,
        [`${mx ? "mx-" + mx : ""}`]: mx,
        [`${my ? "my-" + my : ""}`]: my,
        [`${ml ? "ml-" + ml : ""}`]: ml,
        [`${mr ? "mr-" + mr : ""}`]: mr,
        [`${mt ? "mt-" + mt : ""}`]: mt,
        [`${mb ? "mb-" + mb : ""}`]: mb,
        [`${px ? "px-" + px : ""}`]: px,
        [`${py ? "py-" + py : ""}`]: py,
        [`${pl ? "pl-" + pl : ""}`]: pl,
        [`${pr ? "pr-" + pr : ""}`]: pr,
        [`${pt ? "pt-" + pt : ""}`]: pt,
        [`${pb ? "pb-" + pb : ""}`]: pb,
      })}
    >
      {title && <h3 className="segment-title">{title}</h3>}
      {header && <h3>{header}</h3>}
      {children && children}
      {loading && <Loader />}
    </Type>
  );
};

export default Segment;
